var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0078E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80364 10.5089C6.84828 10.5089 6.89292 10.5089 6.89292 10.5089C7.0715 10.5089 7.25007 10.375 7.29471 10.1964C7.78578 8.23215 9.52686 6.84822 11.5358 6.80357C13.3215 6.80357 14.9287 7.91965 15.5983 9.61608L14.7947 10.4197C14.7501 10.4643 14.7947 10.5536 14.8394 10.5536H16.9376C16.9822 10.5536 17.0269 10.5089 17.0269 10.4643V8.32144C17.0269 8.23215 16.9376 8.18751 16.893 8.27679L16.1787 9.03572C15.3751 7.16072 13.5447 6 11.5358 6C9.12507 6.04464 7.0715 7.69643 6.53578 10.0179C6.44649 10.2411 6.58042 10.4643 6.80364 10.5089Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4108 17.7859L15.5536 14.8395C16.0447 14.2145 16.4018 13.5002 16.625 12.7413C16.7143 12.5181 16.5804 12.2949 16.4018 12.2502C16.2232 12.2056 15.9554 12.2949 15.9107 12.4734C15.9107 12.5181 15.9107 12.5181 15.9107 12.5627C15.4197 14.527 13.6786 15.9556 11.625 15.9556C9.8393 15.9556 8.23215 14.8395 7.56251 13.1877L8.36608 12.3395C8.41072 12.2949 8.36608 12.2056 8.32144 12.2056H6.08929C6.04464 12.2056 6 12.2502 6 12.2949V14.4824C6 14.5716 6.08929 14.6163 6.13393 14.527L6.84822 13.7681C7.74108 15.5538 9.5268 16.7145 11.5357 16.7592C12.7857 16.7592 14.0357 16.2681 14.9732 15.4199L17.8304 18.3663C17.9643 18.5449 18.2322 18.5449 18.3661 18.3663C18.5447 18.2324 18.5447 17.9645 18.4108 17.7859Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFind);
export default __webpack_public_path__ + "static/media/active-find.ad25ae288b5200478c7812c5ebba38be.svg";
export { ForwardRef as ReactComponent };